import { makeAutoObservable, toJS } from "mobx";

export class SearchStore {
    resetClearConfig = {
        defaultSearchParamClearable: true,
        urlSearchParamClearable: false,
    };
    constructor(resetClearConfig) {
        makeAutoObservable(this);
        if (resetClearConfig) {
            this.resetClearConfig = resetClearConfig;
        }
    }

    /**
     * 表单搜索条件 ，不再包含默认值
     * @type {{}}
     */
    search = {};
    /**
     * 页面history路由state传值参数
     */
    pageParam = {};
    /**
     * 默认参数
     */
    defaultSearchParam = {};

    setValue(key, value) {
        if (value === "") {
            delete this.search[key];
        } else {
            this.search[key] = value;
        }
    }

    getSearch() {
        return this.search;
    }

    getUrlSearchParam() {
        let params = {};
        window.location.search
            .slice(1)
            .split("&")
            .map(item => {
                let [key, value] = item.split("=");
                if (key !== "" && key !== "config_id" && key !== "page_title" && key !== "r") {
                    params[key] = value;
                }
            });
        return params;
    }

    /**
     * 设置默认搜索参数
     * @param defaultSearch
     */
    setDefaultSearchParam(defaultSearch) {
        Object.entries(defaultSearch).map(([key, value]) => {
            this.defaultSearchParam[key] = value;
        });
        Object.entries(defaultSearch).map(([key, value]) => {
            this.search[key] = value;
        });
    }

    /**
     * 设置表单搜索条件
     * @param search
     */
    setSearchParam(search) {
        Object.entries(search).map(([key, value]) => {
            this.search[key] = value;
        });
    }

    /**
     * 设置默认清空开关控制
     * @param {"defaultSearchParamClearable"|"urlSearchParam"} key
     * @param {boolean} value
     */
    setResetClearConfigByKeyValue(key, value) {
        this.resetClearConfig[key] = value;
    }
    /**
     * 默认参数
     */
    getDefaultSearchParam() {
        return this.defaultSearchParam;
    }

    /**
     * 重置
     */
    reset() {
        this.search = {};
        this.pageParam = {};
        if (this.resetClearConfig.defaultSearchParamClearable) {
            this.defaultSearchParam = {};
        } else {
            Object.entries(this.defaultSearchParam).map(([key, value]) => {
                this.setValue(key, value);
            });
        }
        if (!this.resetClearConfig.urlSearchParamClearable) {
            Object.entries(this.getUrlSearchParam()).map(([key, value]) => {
                this.setValue(key, decodeURIComponent(value));
            });
        }
    }

    /**
     * 组装搜索条件参数
     * @return {{}}
     */
    assembleSearch(needDispose) {
        //1 放地址栏参数
        // const urlSearchParam = this.getUrlSearchParam();
        // console.log("urlSearchParam",toJS(urlSearchParam))
        //2.放默认参数
        // const defaultSearchParam = this.getDefaultSearchParam();
        // console.log("defaultSearchParam",toJS(defaultSearchParam))
        //3. 放表单参数
        const formSearch = this.getSearch();
        // console.log("formSearch",toJS(formSearch))
        //4. 合并以上几类参数。
        // 当一个参数同时在以上几类参数存在时，覆盖优先级依次降低  formSearch->defaultSearchParam->urlSearchParam
        let mergeParam = { ...formSearch };
        if (needDispose) {
            Object.entries(mergeParam).map(([key, value]) => {
                if (typeof value !== "string") return;
                if (value === "") {
                    //表示置空字段，请求接口不再传该字段
                    delete mergeParam[key];
                }
                if (~value.indexOf(",")) {
                    //处理多行输入，字段空的情况
                    if (value.split(",").filter(v => !!v)?.length) {
                        mergeParam[key] = value
                            .split(",")
                            .filter(v => !!v)
                            .join(",");
                    } else {
                        delete mergeParam[key]; //未知，旧逻辑
                    }
                }
            });
        }

        return mergeParam;
    }
}
